var $09586c378ac09021$exports = {};
const $09586c378ac09021$var$canvas = document.getElementById('canvas');
const $09586c378ac09021$var$ctx = $09586c378ac09021$var$canvas.getContext('2d');
// Set canvas size to window size
function $09586c378ac09021$var$resize() {
    $09586c378ac09021$var$canvas.width = window.innerWidth;
    $09586c378ac09021$var$canvas.height = window.innerHeight;
}
window.addEventListener('resize', $09586c378ac09021$var$resize);
$09586c378ac09021$var$resize();
// Animation variables
let $09586c378ac09021$var$time = 0;
const $09586c378ac09021$var$colors = [
    '#FF0000',
    '#00FF00',
    '#0000FF',
    '#FFFF00',
    '#FF00FF',
    '#00FFFF'
];
let $09586c378ac09021$var$colorIndex = 0;
function $09586c378ac09021$var$draw() {
    $09586c378ac09021$var$time += 0.02;
    // Create a gradient background that shifts over time
    const gradient = $09586c378ac09021$var$ctx.createLinearGradient(0, 0, $09586c378ac09021$var$canvas.width, $09586c378ac09021$var$canvas.height);
    gradient.addColorStop(0, $09586c378ac09021$var$colors[$09586c378ac09021$var$colorIndex % $09586c378ac09021$var$colors.length]);
    gradient.addColorStop(0.5, $09586c378ac09021$var$colors[($09586c378ac09021$var$colorIndex + 2) % $09586c378ac09021$var$colors.length]);
    gradient.addColorStop(1, $09586c378ac09021$var$colors[($09586c378ac09021$var$colorIndex + 4) % $09586c378ac09021$var$colors.length]);
    $09586c378ac09021$var$ctx.fillStyle = gradient;
    $09586c378ac09021$var$ctx.fillRect(0, 0, $09586c378ac09021$var$canvas.width, $09586c378ac09021$var$canvas.height);
    // Draw psychedelic circles
    for(let i = 0; i < 10; i++){
        const x = $09586c378ac09021$var$canvas.width / 2 + Math.cos($09586c378ac09021$var$time + i) * 100;
        const y = $09586c378ac09021$var$canvas.height / 2 + Math.sin($09586c378ac09021$var$time * 1.5 + i) * 100;
        const radius = 50 + Math.sin($09586c378ac09021$var$time * 2 + i) * 30;
        $09586c378ac09021$var$ctx.beginPath();
        $09586c378ac09021$var$ctx.arc(x, y, radius, 0, Math.PI * 2);
        $09586c378ac09021$var$ctx.fillStyle = $09586c378ac09021$var$colors[($09586c378ac09021$var$colorIndex + i) % $09586c378ac09021$var$colors.length];
        $09586c378ac09021$var$ctx.fill();
        $09586c378ac09021$var$ctx.strokeStyle = 'rgba(255, 255, 255, 0.5)';
        $09586c378ac09021$var$ctx.lineWidth = 2;
        $09586c378ac09021$var$ctx.stroke();
    }
    // Slowly cycle through colors
    if (Math.floor($09586c378ac09021$var$time * 10) % 20 === 0) $09586c378ac09021$var$colorIndex = ($09586c378ac09021$var$colorIndex + 1) % $09586c378ac09021$var$colors.length;
    requestAnimationFrame($09586c378ac09021$var$draw);
}
$09586c378ac09021$var$draw();


//# sourceMappingURL=index.8fded5a2.js.map
